var map = {
	"./burger-menu.svg": "57cc",
	"./clock-icon.svg": "4c66",
	"./close-icon.svg": "6d3d",
	"./error.svg": "9745",
	"./facebook-icon.svg": "d7a7",
	"./location-icon.svg": "cc85",
	"./phone-icon.svg": "0ace",
	"./success.svg": "5e96"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "bcb7";